export const startAccountSetup = async () => {
    
      // const {  token, copyApiEndPoint, isCopying, title, submitText, instructionTitle} = functionParameters;
      // let {smartboxStorageName, modelPath, url } = functionParameters;

      const url = `${window.apiEndPoint}/apps/${window.appUserInterface}/profileDetails/model/${window.userLanguage}`;

      const functionParameters = {
            url,
            modelPath:"accountSetup",
            submitText:"Next",
            title: "Account setup"
      };
    

      const smartboxStorageName = smartboxStorageName || "retrieveModelForAccountSetup";

      const retrieveModel = (await import(/* webpackPrefetch: true */ "../general/retrieveModel")).retrieveModel;

      functionParameters["submissionFuncPath"] = "apps/profileDetails/saveAccountSetup";
      functionParameters["sideMenuToUse"] = "profileDetails";
      functionParameters["smartboxStorageName"] = smartboxStorageName;

      return await retrieveModel(functionParameters);
};
